import React from 'react';
import { Fragment, useState } from "react";
import getUrl from "../../../../../Utility/GetUrl";
import { postData } from "../../../../../Utility/GlobalService";
import SectionFormCard from "../../../Components/Section/SectionFormCard";
import TextAreaInput from "../../../Components/textareaInput";
import TextInput from "../../../Components/textInput";

const HomePageMistakes = ()=>{
    const [mistakesSectionTitle,setMistakesSectionTitle] = useState("");
    const [mistakesSectionContent,setMistakesSectionContent] = useState("");
    const [mistakesSectionImage,setMistakesSectionImageinput] = useState("");

    const handleMistakesSectionTitleSubmit = (event)=>{
        event.preventDefault();
        const data = {
          title: mistakesSectionTitle
        };
        postData(`${getUrl()}/mistakes/title`,data);
        setMistakesSectionTitle("");
      }
      const handleMistakesSectionContentSubmit = (event)=>{
        event.preventDefault();
        const data = {
          content: mistakesSectionContent
        };
        postData(`${getUrl()}/mistakes/content`,data);
        setMistakesSectionContent("");
      }
    
      const handleMistakesSectionImageUpload = (event)=>{
        event.preventDefault();
        let data = new FormData();
        data.append('mistakeImage',mistakesSectionImage);
        postData(`${getUrl()}/mistakes/image`,data);
      }
    return (
        <Fragment>
            <SectionFormCard 
                sectionname="Mistakes Section"
                sectiontitle = {mistakesSectionTitle}
                handleSectionTitle = {handleMistakesSectionTitleSubmit}
                setSectionTitle = {setMistakesSectionTitle}
                sectioncontent = {mistakesSectionContent}
                handleSectionContent = {handleMistakesSectionContentSubmit}
                setSectionContent = {setMistakesSectionContent}
                setFileinput = {setMistakesSectionImageinput}
                handleFileUpload = {handleMistakesSectionImageUpload}
            />
        </Fragment>
    )
}
export default HomePageMistakes;